<template>
  <div class="breakdown-card">
    <div class="w-full p-4 flex items-center justify-between">
      <BaseText type="label" size="sm" class="text-text-normal">
        Video Analysis
      </BaseText>
      <BaseText type="label" size="sm" class="text-text-muted">
        Audience Retention
      </BaseText>
    </div>
    <!-- Line Graph -->
    <div class="w-full pl-4 pr-6 pt-1 pb-4">
      <RetentionLineGraph 
        ref="retentionLineGraph" 
        :advertisement="advertisement"
        :retention-series="retentionSeries"
        @updatePlayerTime="handlePlayerTimeUpdate"
      />
    </div>
  </div>
</template>

<script>
import RetentionLineGraph from './video/RetentionLineGraph.vue'

export default {
  name: 'VideoAnalysisBreakdown',
  components: {
    RetentionLineGraph
  },
  props: {
    advertisement: {
      type: Object,
      required: true
    },
    retentionSeries: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      videoPlayer: null,
      customPlayEvent: null
    }
  },
  created () {
    this.customPlayEvent = new CustomEvent('playedexternally')
  },
  mounted () {
    this.$nextTick(() => {
      this.videoPlayer = document.querySelector('.drawer-video')
      this.videoPlayer.addEventListener('timeupdate', this.handleProgressBarUpdate)
    })
  },
  beforeDestroy () {
    this.videoPlayer.removeEventListener('timeupdate', this.handleProgressBarUpdate)
  },
  methods: {
    handleProgressBarUpdate (event) {
      // Update the progress bar
      const player = event.target
      if (this.$refs.retentionLineGraph) {
        this.$refs.retentionLineGraph.updateProgress(player.currentTime)
      }
    },
    handlePlayerTimeUpdate (time) {
      // Update the video player's time
      const player = this.videoPlayer
      if (!player.paused) {
        player.dispatchEvent(this.customPlayEvent)
      }
      player.currentTime = time
    }
  }
}
</script>

<style scoped></style>